// extracted by mini-css-extract-plugin
export default {"table":"OrdersView_table__DqMuq"};